import { BroadLineOfBusiness } from '@app/enumerations';

export default class PolicySearchResult {

	public policyId: number | null = null;
	public broadLineOfBusinessCode: BroadLineOfBusiness | null = null;
	public policyName: string | null = null;
	public recordType: string | null = null;
	public oldPolicyNumber: string | null = null;
	public userFirst: string | null = null;
	public userLast: string | null = null;
	public insuredFirst: string | null = null;
	public insuredLast: string | null = null;
	public insuredAddress1: string | null = null;
	public insuredAddress2: string | null = null;
	public insuredCity: string | null = null;
	public insuredState: string | null = null;
	public insuredZip: string | null = null;
	public propertyAddress1: string | null = null;
	public propertyAddress2: string | null = null;
	public propertyCity: string | null = null;
	public propertyState: string | null = null;
	public propertyZip: string | null = null;
	public propertyType: string | null = null;
	public isActive: boolean | null = null;
	public isQuote: boolean | null = null;

	public constructor() {

	}
};